import './hero.scss';


const hero = () => {

    document.addEventListener('DOMContentLoaded', function () {
        const secondaryBtn = document.getElementById('openVideoModal');
        const modal = document.getElementById('videoModal');
        const closeModal = document.querySelector('#videoModal .close');
        if (modal) {
            var video = modal.querySelector('#modal-video');
        }

        if (secondaryBtn && closeModal && video) {

            secondaryBtn.addEventListener('click', function () {
                modal.style.display = 'flex';
                video.play();

            });

            closeModal.addEventListener('click', function () {
                modal.style.display = 'none';
                video.pause();
            });

            window.addEventListener('click', function (event) {
                if (event.target === modal) {
                    modal.style.display = 'none';
                    video.pause();
                }
            });
        }
        document.addEventListener('keyup', (e) => {
            console.log(e);
            if(e.keyCode === 27) {
                modal.style.display = 'none';
                video.pause();
            }
        });
    });

}

export default hero;